<style lang="less" scoped>
  .td_left {width: 200px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  .f_hids {width:200px;color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  .spans {margin-left: 140px;color: #606266;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first .introduce1 {width: 750px;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .ssgj_tr /deep/ .el-input {width: 400px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 99%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
  .formBox {padding-bottom: 70px;}
  .inputCol{width: 50px;}
  .input2{margin-left: 5px;}
  /deep/.video-js .vjs-big-play-button{top: 45%;left: 45%;}
  /deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
  /deep/.hide .el-upload--picture-card {display: none;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" :rules="rules" class="formBox">
      <table>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('company')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司名称
          </td>
          <td class="after title_right" v-if="this.$route.path === '/Qyzsgl' || '/QyzsUpdate'">
            <el-form-item>
              <el-input v-model="form.company" placeholder="请输入公司名称" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('company')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司级别
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-select clearable v-model="form.level" placeholder="级别">
                <el-option v-for="item in level_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('type')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司类型
          </td>
          <td class="after" >
            <el-form-item>
              <el-select clearable v-model="form.type" placeholder="请选择分类" class="select classification">
                <el-option v-for="item in options_companyType" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>形象图片
          </td>
          <td class="after">
              <el-upload
                v-if="this.$route.path === '/Qyzsgl'"
                :action="url"
                :limit="1"
                list-type="picture-card"
                ref="uploadPic1"
                :before-upload="beforeUploadPicture"
                :on-preview="handlePictureCardPreview"
                :on-success="onSuccess"
                :on-remove="handleRemovePicture"
                :on-exceed="exceed"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                @mouseover.native="getPhoUrl">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-upload
                v-else
                :action="url"
                :limit="1"
                list-type="picture-card"
                ref="uploadPic1"
                :file-list="fileList1"
                :before-upload="beforeUploadPicture"
                :on-preview="handlePictureCardPreview"
                :on-success="onSuccess"
                :on-remove="handleRemovePicture"
                :on-exceed="exceed"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                @mouseover.native="getPhoUrl">
                <i class="el-icon-plus"></i>
              </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" />
            </el-dialog>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('bannerthumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>横幅
          </td>
          <td class="after">
              <el-upload
                v-if="this.$route.path === '/Qyzsgl'"
                :action="url"
                :limit="1"
                list-type="picture-card"
                ref="uploadPic4"
                :before-upload="beforeUploadPicture"
                :on-preview="handlePictureCardPreview"
                :on-success="onSuccess2"
                :on-remove="handleRemovePicture"
                :on-exceed="exceed"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                @mouseover.native="getPhoUrl">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-upload
                v-else
                :action="url"
                :limit="1"
                list-type="picture-card"
                ref="uploadPic4"
                :file-list="fileList4"
                :before-upload="beforeUploadPicture"
                :on-preview="handlePictureCardPreview"
                :on-success="onSuccess2"
                :on-remove="handleRemovePicture"
                :on-exceed="exceed"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                @mouseover.native="getPhoUrl">
                <i class="el-icon-plus"></i>
              </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" />
            </el-dialog>
          </td>
        </tr>
        <tr class="jianjie_tr">
          <td class="td_left">
            <span v-if="isMandatory('introduce')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>企业简介
          </td>
          <td class="after" >
            <el-form-item>
              <el-input type="textarea" :rows="2" placeholder="请输入内容" class="introduce" v-model="form.introduce"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('catid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>主营行业
          </td>
          <td class="after" >
            <el-form-item>
              <el-select clearable v-model="form.catid" placeholder="请选择分类" class="select classification">
                <el-option v-for="item in options_Mainindustry" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="jianjie_tr">
          <td class="td_left">
            <span v-if="isMandatory('business')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>主要经营范围
          </td>
          <td class="after" >
            <el-form-item>
              <el-input type="textarea" :rows="2" placeholder="请输入内容" class="introduce" v-model="form.business"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="ssgj_tr">
          <td class="td_left">
            <span v-if="isMandatory('mode')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>经营模式
          </td>
          <td class="after">
            <el-checkbox-group v-model="form.mode" :min="0" :max="2"> <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
            <span class="spans">(最多可选2种)</span>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('size')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司规模
          </td>
          <td class="after" >
            <el-form-item>
              <el-select clearable v-model="form.size" placeholder="" class="select classification">
                <el-option v-for="item in options_companySize" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
         <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('regunit')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>注册资本
          </td>
          <td class="after" >
            <el-form-item>
              <el-select clearable v-model="form.regunit" placeholder="" class="select classification">
                <el-option v-for="item in options_registeredCapital" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-input v-model="form.capital" placeholder="" class="input2"></el-input> 万
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('regyear')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司成立年份
          </td>
          <td class="after" >
            <el-input v-model="form.regyear" placeholder=""></el-input>（年份，如：2004）
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('address')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司地址
          </td>
          <td class="after" >
            <el-input v-model="form.address" placeholder=""></el-input>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('postcode')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>邮政编码
          </td>
          <td class="after" >
            <el-input v-model="form.postcode" placeholder=""></el-input>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('telephone')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司电话
          </td>
          <td class="after" >
            <el-form-item prop="telephone">
              <el-input v-model="form.telephone" placeholder="" >></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('fox')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司传真
          </td>
          <td class="after" >
            <el-form-item prop="fax">
              <el-input placeholder="" v-model="form.fax"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('mail')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司Email
          </td>
          <td class="after" >
            <el-form-item prop="email">
              <el-input v-model="form.email" placeholder=""></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('homepage')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司网址
          </td>
          <td class="after" >
            <el-form-item prop="homepage">
              <el-input v-model="form.homepage" placeholder=""></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('contacts')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>联系人
          </td>
          <td class="after" >
            <el-input v-model="form.contacts" placeholder=""></el-input>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('phone')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>手机号码
          </td>
          <td class="after" >
            <el-input v-model="form.phone" placeholder=""></el-input>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('gzh')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>微信公众号
          </td>
          <td class="after" >
            <el-input v-model="form.gzh" placeholder=""></el-input>
          </td>
        </tr>
         <tr>
          <td class="td_left">
            <span v-if="isMandatory('gzhqr')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公众号二维码
          </td>
          <td class="after">
            <el-form-item>
              <el-upload
                v-if="this.$route.path === '/Qyzsgl'"
                :action="url"
                :limit="1"
                list-type="picture-card"
                ref="uploadPic2"
                :before-upload="beforeUploadPicture"
                :on-preview="handlePictureCardPreview"
                :on-success="onSuccess1"
                :on-remove="handleRemovePicture"
                :on-exceed="exceed"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                @mouseover.native="getPhoUrl">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-upload
                v-else
                :action="url"
                :limit="1"
                list-type="picture-card"
                ref="uploadPic2"
                :file-list="fileList2"
                :before-upload="beforeUploadPicture"
                :on-preview="handlePictureCardPreview"
                :on-success="onSuccess1"
                :on-remove="handleRemovePicture"
                :on-exceed="exceed"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                @mouseover.native="getPhoUrl">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" />
            </el-dialog>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('sell')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>销售的产品（服务）
          </td>
          <td class="after" >
            <el-input v-model="form.sell" placeholder=""></el-input>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('buy')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>采购的产品（服务）
          </td>
          <td class="after">
            <el-input v-model="form.buy" placeholder=""></el-input>
          </td>
        </tr>
        <tr v-if="!checked_External_links">
          <td class="td_left">
            <span v-if="isMandatory('catid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>企业内容
          </td>
          <td class="after">
            <div id="editor" style="position:relative;z-index: 1;"></div>
          </td>
        </tr>
         <tr>
          <td class="td_left">
            <span v-if="isMandatory('video')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>上传公司视频
          </td>
          <td class="after">
            <el-form-item>
              <el-upload
                v-if="this.$route.path === '/Qyzsgl'"
                class="upload-demo"
                :action="url"
                :limit="1"
                ref="uploadPic3"
                :on-success="onVideoSuccess"
                :on-remove="handleRemoveVideo"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                :before-upload="beforeUploadVideo"
                :on-exceed="exceed"
                @mouseover.native="getVidUrl">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <el-button style="margin-left: 15px;" size="small" type="success" @click="preview()">点击预览</el-button>
              </el-upload>
              <el-upload
                v-else
                class="upload-demo"
                :action="url"
                :limit="1"
                ref="uploadPic3"
                :on-success="onVideoSuccess"
                :on-remove="handleRemoveVideo"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                :file-list="fileList3"
                :before-upload="beforeUploadVideo"
                :on-exceed="exceed"
                @mouseover.native="getVidUrl">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <el-button style="margin-left: 15px;" size="small" type="success" @click="preview()">点击预览</el-button>
              </el-upload>
            </el-form-item>
            <el-dialog :visible.sync="dialogVisible1">
              <video-player ref="videoPlayer" :playsinline="true"  :options="playerOptions"></video-player>
            </el-dialog>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Qyzsgl'">添加</el-button>
      <el-button type="success" @click="modification()" v-else-if="this.$route.path === '/QyzsUpdate'">确定修改</el-button>
      <el-button type="success" @click="isPass()" v-else-if="this.$route.path === '/QyzsLook'">通过</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Qyzsgl'">取消</el-button>
      <el-button @click="backtrack()" v-else-if="this.$route.path === '/QyzsUpdate'">返回</el-button>
      <el-button type="danger" @click="notPass()" v-else-if="this.$route.path === '/QyzsLook'">不通过</el-button>
      <el-button  @click="backtrack()" v-if="this.$route.path === '/QyzsLook'">返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * 李旭
 * 线上云展-企业信息添加
 */
import playVideo from '../../../src/plugins/app/method/playVideo'
export default {
  components: {
  },
  mixins: [playVideo],
  props: ['updataID', 'lookID'],
  data()
  {
    //   //电话—座机验证规则
    let InputTelephone = (rule, value, callback) =>
    {
      let regtel = /^(0\d{2,3})-?(\d{7,8})$/
      if (!value)
        return callback(new Error('电话(座机)不能为空'))
      else
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确座机号'))
        else
          callback()
      }
    }
    //邮箱验证规则
    let InputEmail = (rule, value, callback) =>
    {
      let regtel = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!value)
        return callback(new Error('邮箱不能为空'))
      else
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确的邮箱'))
        else
          callback()
      }
    }
    return {
      roleid: '1',
      url: '',
      checked_External_links: false,
      form: {
        company: '',
        level: '',
        type: null,
        catid: null,
        business: '',
        mode: [],
        size: null,
        capital: '',
        regunit: null,
        regyear: '',
        address: '',
        postcode: '',
        telephone: '',
        fax: '',
        email: '',
        homepage: '',
        contacts: '',
        phone: '',
        gzh: '',
        sell: '',
        buy: '',
        introduce: '',
        content: '',
        thumb: '',
        gzhqr: '',
        video: '',
        bannerthumb: ''
      },
      // 富文本对象
      editor: null,
      userorgid: null,
      cities: ['制造商', '贸易商', '服务商', '其他机构'],
      //级别选项
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' },
        { value: '3', label: '3 级' },
        { value: '4', label: '4 级' },
        { value: '5', label: '5 级' },
        { value: '6', label: '6 级' },
        { value: '7', label: '7 级' },
        { value: '8', label: '8 级' },
        { value: '9', label: '9 级' }
      ],
      //公司类型
      options_companyType: [
        { value: '企业单位', label: '企业单位' },
        { value: '事业单位或社会团体', label: '事业单位或社会团体' },
        { value: '个体经营', label: '个体经营' },
        { value: '其他', label: '其他' }
      ],
      //主营行业
      options_Mainindustry: [
        { value: 84, label: '设备药剂企业' },
        { value: 82, label: '矿山企业' },
        { value: 81, label: '地勘单位' },
        { value: 85, label: '珠宝企业' },
        { value: 87, label: '投融资企业' },
        { value: 88, label: '贸易企业' },
        { value: 83, label: '科研单位' },
        { value: 89, label: '其它企业' }
      ],
      //公司规模
      options_companySize: [
        { value: '1-49人', label: '1-49人' },
        { value: '50-99人', label: '50-99人' },
        { value: '100-499人', label: '100-499人' },
        { value: '500-999人', label: '500-999人' },
        { value: '1000-3000人', label: '1000-3000人' },
        { value: '3000-5000人', label: '3000-5000人' },
        { value: '5000-10000人', label: '5000-10000人' },
        { value: '10000以上', label: '10000以上' }
      ],
      //资本
      options_registeredCapital: [
        { value: '人民币', label: '人民币' },
        { value: '港元', label: '港元' },
        { value: '台币', label: '台币' },
        { value: '美元', label: '美元' },
        { value: '欧元', label: '欧元' },
        { value: '英镑', label: '英镑' }
      ],
      //图片预览弹框
      dialogVisible: false,
      //图片预览路径
      dialogImageUrl: '',
      dialogVisible1: false,
      fileList1: [{url: ''}],
      fileList2: [{url: ''}],
      fileList3: [{url: '', name: ''}],
      fileList4: [{url: ''}],
      inputStas: '',
      examine: '',
      //rules对象的属性名要与表单中prop绑定的名字一致
      rules: {
        telephone: [
          { validator: InputTelephone, trigger: 'blur' }
        ],
        email: [
          { validator: InputEmail, trigger: 'blur' }
        ]
      },
      //表名
      tabname: 'dmcn_company',
      //fld表数据
      fldData: [],
      hideUploadEdit: false
    }
  },
  async created()
  {
    //创建富文本编辑器
    setTimeout(() =>
    {
      let that = this
      window.public.createEditor(that)
    }, 50)
    this.fldData = await window.public.validation(this.tabname)
    this.isgetData()
    //根据用户判断审核状态
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    this.username = userInfo.userno
    this.getUserorganise(this.username)
    if (userInfo.userno === 'admin')
      this.examine = 0
    else
      this.examine = 1
  },
  mounted()
  {
    this.judge()
  },
  methods: {
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 26,
        retAtt: 1,
        company: this.form.company,
        level: this.form.level,
        type: this.form.type,
        catid: this.form.catid,
        business: this.form.business,
        mode: this.form.mode.toString(),
        size: this.form.size,
        capital: this.form.capital,
        regunit: this.form.regunit,
        regyear: this.form.regyear,
        address: this.form.address,
        postcode: this.form.postcode,
        telephone: this.form.telephone,
        fax: this.form.fax,
        mail: this.form.email,
        homepage: this.form.homepage,
        contacts: this.form.contacts,
        phone: this.form.phone,
        gzh: this.form.gzh,
        sell: this.form.sell,
        buy: this.form.buy,
        introduce: this.form.introduce,
        thumb: this.form.thumb,
        gzhqr: this.form.gzhqr,
        video: this.form.video,
        bannerthumb: this.form.bannerthumb,
        examine: this.examine,
        organiseid: this.userorgid
      }
      window.post.getPost(obj).then((ret) =>
      {
        let objcontent = {
          cmd: 'addWithId',
          _major: 11,
          _minor: 27,
          retAtt: 1,
          id: ret.id,
          content: this.form.content
        }
        window.post.getPost(objcontent).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
            this.$emit('removeTab')
            this.$store.commit('onIsLb', '1')
          }
        })
      })
    },
    //获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/QyzsUpdate')
        this.getData()
      else if (this.$route.path === '/QyzsLook')
        this.getData()
      else if (this.$route.path === '/Qyzsgl')
        return false
    },
    judge()
    {
      if (this.$route.path === '/QyzsUpdate')
        this.inputStas = false
      else if (this.$route.path === '/Qyzsgl')
        this.inputStas = true
      else if (this.$route.path === '/QyzsLook')
        this.inputStas = true
    },
    getUserorganise(val)
    {
      let paras = {
        cmd: 'query',
        _major: 99,
        _minor: 13,
        _exp: `no = '${val}'`
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.userorgid = ret[0].organiseid
      })
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 26,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.company = ret[0].company
        this.form.level = ret[0].level
        this.form.type = ret[0].type
        this.form.catid = ret[0].catid
        this.form.business = ret[0].business
        this.form.mode = ret[0].mode
        this.form.size = ret[0].size
        this.form.capital = ret[0].capital
        this.form.regunit = ret[0].regunit
        this.form.regyear = ret[0].regyear
        this.form.postcode = ret[0].postcode
        this.form.address = ret[0].address
        this.form.fax = ret[0].fax
        this.form.email = ret[0].mail
        this.form.homepage = ret[0].homepage
        this.form.contacts = ret[0].contacts
        this.form.phone = ret[0].phone
        this.form.gzh = ret[0].gzh
        this.form.sell = ret[0].sell
        this.form.buy = ret[0].buy
        this.form.telephone = ret[0].telephone
        this.form.introduce = ret[0].introduce
        this.form.thumb = ret[0].thumb
        this.form.gzhqr = ret[0].gzhqr
        this.form.bannerthumb = ret[0].bannerthumb
        this.form.video = ret[0].video
        this.fileList1[0].url = ret[0].thumb !== '' ? ret[0].thumb : 'static/images/moren.jpg'
        this.fileList2[0].url = ret[0].gzhqr !== '' ? ret[0].gzhqr : 'static/images/moren.jpg'
        this.fileList4[0].url = ret[0].bannerthumb !== '' ? ret[0].bannerthumb : 'static/images/moren.jpg'
        this.fileList3[0].url = ret[0].video
        this.fileList3[0].name = ret[0].video.substring(ret[0].video.lastIndexOf('/') + 1, ret[0].video.length)
      })
      let paras1 = {
        cmd: 'query',
        _major: 11,
        _minor: 27,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras1).then((ret) =>
      {
        this.form.content = ret[0].content
        // 重新设置编辑器内容
        this.editor.txt.html(ret[0].content)
      })
    },
    //确定修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 26,
        retAtt: 1,
        id: this.form.id,
        company: this.form.company,
        level: this.form.level,
        type: this.form.type,
        catid: this.form.catid,
        business: this.form.business,
        mode: this.form.mode.toString(),
        size: this.form.size,
        capital: this.form.capital,
        regunit: this.form.regunit,
        regyear: this.form.regyear,
        address: this.form.address,
        postcode: this.form.postcode,
        telephone: this.form.telephone,
        fax: this.form.fax,
        mail: this.form.email,
        homepage: this.form.homepage,
        gzh: this.form.gzh,
        sell: this.form.sell,
        buy: this.form.buy,
        introduce: this.form.introduce,
        thumb: this.form.thumb,
        gzhqr: this.form.gzhqr,
        video: this.form.video,
        bannerthumb: this.form.bannerthumb
      }
      window.post.getPost(obj).then((ret) =>
      {
        let objcontent = {
          cmd: 'updateAtt',
          _major: 11,
          _minor: 27,
          retAtt: 1,
          id: ret.id,
          content: this.form.content
        }
        window.post.getPost(objcontent).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
            this.dialogVisible = false
            this.$router.push({path: '/Qyzsgl'})
            this.$store.commit('onActiveName', '1')
          }
        })
      })
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/Qyzsgl'})
      this.$store.commit('onActiveName', '1')
    },
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    getVidUrl()
    {
      let that = this
      window.public.onUploadVideo(that)
    },
    preview()
    {
      if (this.$route.path === '/QyzsUpdate' || this.$route.path === '/QyzsLook')
      {
        this.playerOptions.sources[0].src = this.fileList3[0].url
        this.dialogVisible1 = true
      }
      else if (this.$route.path === '/Qyzsgl')
      {
        this.playerOptions.sources[0].src = this.form.video
        this.dialogVisible1 = true
      }
    },
    onSuccess1(response)
    {
      let Ip = window.location.hostname
      let prefix = ''
      if (Ip === 'www.camining.cn')
        prefix = 'http://www.camining.cn/uploadfile/'
      else if (Ip === 'camining.cn')
        prefix = 'http://www.camining.cn/uploadfile/'
      else
        prefix = 'http://192.168.2.201:8083/gisdm/uploadfile/'
      this.form.gzhqr = `${prefix}${response[0].filename}`
    },
    onSuccess2(response)
    {
      let Ip = window.location.hostname
      let prefix = ''
      if (Ip === 'www.camining.cn')
        prefix = 'http://www.camining.cn/uploadfile/'
      else if (Ip === 'camining.cn')
        prefix = 'http://www.camining.cn/uploadfile/'
      else
        prefix = 'http://192.168.2.201:8083/gisdm/uploadfile/'
      this.form.bannerthumb = `${prefix}${response[0].filename}`
    },
    //不通过
    notPass()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 26,
        retAtt: 1,
        id: this.updataID,
        examine: 4
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '该条已为不通过', type: 'error', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/Qyzsgl'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //通过
    isPass()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 26,
        retAtt: 1,
        id: this.updataID,
        examine: 0
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '审核成功', type: 'success', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/Qyzsgl'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //视频上传之前的钩子
    beforeUploadVideo(file)
    {
      let that = this
      window.public.beforeUploadVideo(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //视频上传成功
    onVideoSuccess(response)
    {
      let that = this
      window.public.onVideoSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //删除视频
    handleRemoveVideo(fileList)
    {
      let that = this
      window.public.handleRemoveVideo(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/xsyz/QyzsAdd.vue